import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { MenuManagementDeliveryStore } from '@/pages/menu-managements/allocated-menus/service';
import { MenuManagementAllocatedMenuService } from '@/services/AllocatedMenu/MenuManagementAllocatedMenuService';
import { MenuManagementListQueryParams } from '@/services/Service/MenuManagementList';

export type MenuManagementAllocatedMenuListParams =
  MenuManagementListQueryParams;

export type AllocatedMenuListResponse = {
  allocated_menus: MenuManagementDeliveryStore[];
  count: number;
};

export const useMenuManagementAllocatedMenuList = async (
  params: MenuManagementListQueryParams
): Promise<AllocatedMenuListResponse> => {
  const menuManagementAllocatedMenuService =
    new MenuManagementAllocatedMenuService(getClient());
  try {
    const res = await menuManagementAllocatedMenuService.list(params);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
